import script from "./FoodPreferencesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FoodPreferencesModal.vue?vue&type=script&setup=true&lang=ts"

import "./FoodPreferencesModal.vue?vue&type=style&index=0&id=3c762bb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c762bb4"]])

export default __exports__